require.config({
    baseUrl: '../../..'
});

require(
        ['listController', 'formController', "signatureController", "jquery-form"],
        function () {

        },
        function (err) {
            console.error("ERROR: ", err.requireType);
            console.error("MODULES: ", err.requireModules);
        }
);

define("listAndForm", function(){});

